import type { DocNode } from '@atlaskit/adf-schema/doc';
import type { ConfluenceUpdatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

import type { DocumentUpdateCommandProcessor } from '../stream-processors/update-command-processor';
import type { AbortOptions, AbortReason } from '../types/abort-reason';
import type { AIFC_ADF_UPDATE_KEY } from '../types/command-manager';
import { getAgentUpdateMetadata } from '../utils/get-agent-attribution';
import type { PassThroughCommandProps } from './command-handler';
import { StreamingCommandHandler } from './streaming-command-handler';

type AdfUpdatePayload = ConfluenceUpdatePageCommandProperties & {
	key: typeof AIFC_ADF_UPDATE_KEY;
};

export class UpdateCommandHandler extends StreamingCommandHandler<ConfluenceUpdatePageCommandProperties> {
	constructor(
		props: PassThroughCommandProps,
		private updateCommandProcessor: DocumentUpdateCommandProcessor,
	) {
		super(props, 'update');
	}

	process(payload: AdfUpdatePayload): void {
		const { agentInfo, agentAttribution } = getAgentUpdateMetadata(payload);

		this.updateCommandProcessor.streamChunk(
			payload.data.toolCalls,
			payload.isStreamComplete,
			payload.traceId,
			payload.singleInstrumentationId,
			agentInfo,
			payload.isInlineEdit,
			agentAttribution,
			payload.isChatEdit,
			payload.cwrRemixInvokedFrom,
		);
	}

	async finishAction(): Promise<DocNode | undefined> {
		await this.updateCommandProcessor.finish();
		return undefined;
	}

	abort(reason?: AbortReason, options?: AbortOptions): void {
		this.updateCommandProcessor.abort(reason, options);
	}
}
